import { Button } from '@h2hspark/ui';
import * as React from 'react';
import { Link } from 'react-router-dom';

/**
 * The address resolves to nothing at all — no organizer, no published page.
 *
 * Deliberately not the organizer profile's "there is no organizer at this address". That sentence
 * is a specific claim about a specific kind of thing, and answering every unknown URL with it
 * tells somebody who mistyped `/pricng` that H2HSpark has no organizer called `pricng`.
 */
export function NotFoundPage(): React.ReactElement {
  return (
    <div className="mx-auto max-w-xl px-6 py-24 text-center">
      <p className="h2h-eyebrow">404</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight">There is nothing at this address</h1>
      <p className="mt-4 text-muted-foreground">
        The page may have moved, or the link may be out of date.
      </p>
      <div className="mt-8">
        <Button asChild>
          <Link to="/">Back to the home page</Link>
        </Button>
      </div>
    </div>
  );
}
